import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Obt_DownloadSurveyPartnerDataQueryVariables = Types.Exact<{
  criteria: Types.IObtSurveySearchCriteriaInput;
}>;


export type Obt_DownloadSurveyPartnerDataQuery = { __typename?: 'Query', obtDownloadSurveyPartnerData?: { __typename?: 'ObtSurveyDetailsResponse', total?: number | null, surveyList?: Array<{ __typename?: 'ObtSurveyDetails', surveyId?: number | null, waveId?: string | null, partnerNo?: string | null, systemCode?: string | null, masterPartnerNo?: string | null, partnerName?: string | null, category?: string | null, companyCode?: string | null, countryCode?: string | null, otSurveyStatus?: string | null, surveyStatus?: string | null, surveyType?: string | null, surveyRequest?: string | null, masterDataAcceptedDate?: string | null, channelDataAcceptedDate?: string | null, agreementStatusDate?: string | null, provisionalGoLiveDate?: string | null, confirmedGoLiveDate?: string | null, surveySubmissionDate?: string | null, surveySentDate?: string | null, surveySentToProvider?: boolean | null, dateSurveySentToProvider?: string | null, assignedPartnerUserId?: number | null, agreementDownloaded?: boolean | null, agreementStatusId?: number | null, agreementApproverName?: string | null, insertTime?: string | null, masterDataInsertTime?: string | null, updateTime?: string | null, technicalContactName?: string | null, technicalContactEmail?: string | null, technicalContactPhoneNumber?: string | null, connectivityInfoDate?: string | null, surveyActiveStatus?: boolean | null, agreementType?: string | null, assignedPartnerUserName?: string | null, remark?: string | null, partnerId?: string | null, apArPartnerLink?: string | null }> | null } | null };

export type Obt_DownloadSurveyPartnerContactDetailsQueryVariables = Types.Exact<{
  criteria: Types.DownloadSurveyPartnerContactInput;
}>;


export type Obt_DownloadSurveyPartnerContactDetailsQuery = { __typename?: 'Query', obtDownloadSurveyPartnerContactDetails?: Array<{ __typename?: 'IObtContactModel', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, role?: string | null, mail?: string | null, source?: string | null, valid?: boolean | null, name1?: string | null, name2?: string | null, department?: string | null, phone?: string | null, fax?: string | null, error?: string | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null }> | null };

export type Obt_DownloadSurveyPartnerChannelDetailsQueryVariables = Types.Exact<{
  criteria: Types.DownloadSurveyPartnerChannelInput;
}>;


export type Obt_DownloadSurveyPartnerChannelDetailsQuery = { __typename?: 'Query', obtDownloadSurveyPartnerChannelDetails?: Array<{ __typename?: 'ObtPartnerChannel', id?: number | null, partnerno?: string | null, idpartner?: number | null, companycode?: string | null, invprocess?: string | null, validfrom?: string | null, validto?: string | null, status?: string | null, channeltype?: string | null, direction?: string | null, format?: string | null, count?: number | null, provider?: string | null, newProcess?: boolean | null, anlageUser?: string | null, anlageDatum?: string | null, aenderungUser?: string | null, aenderungDatum?: string | null }> | null };

export type Obt_DownloadSurveyExcelQueryVariables = Types.Exact<{
  criteria: Types.IObtSurveySearchCriteriaInput;
}>;


export type Obt_DownloadSurveyExcelQuery = { __typename?: 'Query', obtDownloadSurveyExcel?: string | null };


export const Obt_DownloadSurveyPartnerDataDocument = gql`
    query Obt_DownloadSurveyPartnerData($criteria: IObtSurveySearchCriteriaInput!) {
  obtDownloadSurveyPartnerData(criteria: $criteria) {
    surveyList {
      surveyId
      waveId
      partnerNo
      systemCode
      masterPartnerNo
      partnerName
      category
      companyCode
      countryCode
      otSurveyStatus
      surveyStatus
      surveyType
      surveyRequest
      masterDataAcceptedDate
      channelDataAcceptedDate
      agreementStatusDate
      provisionalGoLiveDate
      confirmedGoLiveDate
      surveySubmissionDate
      surveySentDate
      surveySentToProvider
      dateSurveySentToProvider
      assignedPartnerUserId
      agreementDownloaded
      agreementStatusId
      agreementApproverName
      insertTime
      masterDataInsertTime
      updateTime
      technicalContactName
      technicalContactEmail
      technicalContactPhoneNumber
      connectivityInfoDate
      surveyActiveStatus
      agreementType
      assignedPartnerUserName
      remark
      partnerId
      apArPartnerLink
    }
    total
  }
}
    `;

/**
 * __useObt_DownloadSurveyPartnerDataQuery__
 *
 * To run a query within a React component, call `useObt_DownloadSurveyPartnerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_DownloadSurveyPartnerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_DownloadSurveyPartnerDataQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useObt_DownloadSurveyPartnerDataQuery(baseOptions: Apollo.QueryHookOptions<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables> & ({ variables: Obt_DownloadSurveyPartnerDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>(Obt_DownloadSurveyPartnerDataDocument, options);
      }
export function useObt_DownloadSurveyPartnerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>(Obt_DownloadSurveyPartnerDataDocument, options);
        }
// @ts-ignore
export function useObt_DownloadSurveyPartnerDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>;
export function useObt_DownloadSurveyPartnerDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_DownloadSurveyPartnerDataQuery | undefined, Obt_DownloadSurveyPartnerDataQueryVariables>;
export function useObt_DownloadSurveyPartnerDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>(Obt_DownloadSurveyPartnerDataDocument, options);
        }
export type Obt_DownloadSurveyPartnerDataQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerDataQuery>;
export type Obt_DownloadSurveyPartnerDataLazyQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerDataLazyQuery>;
export type Obt_DownloadSurveyPartnerDataSuspenseQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerDataSuspenseQuery>;
export type Obt_DownloadSurveyPartnerDataQueryResult = Apollo.QueryResult<Obt_DownloadSurveyPartnerDataQuery, Obt_DownloadSurveyPartnerDataQueryVariables>;
export const Obt_DownloadSurveyPartnerContactDetailsDocument = gql`
    query Obt_DownloadSurveyPartnerContactDetails($criteria: DownloadSurveyPartnerContactInput!) {
  obtDownloadSurveyPartnerContactDetails(criteria: $criteria) {
    id
    partnerno
    idpartner
    companycode
    role
    mail
    source
    valid
    name1
    name2
    department
    phone
    fax
    error
    anlageUser
    anlageDatum
    aenderungUser
    aenderungDatum
  }
}
    `;

/**
 * __useObt_DownloadSurveyPartnerContactDetailsQuery__
 *
 * To run a query within a React component, call `useObt_DownloadSurveyPartnerContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_DownloadSurveyPartnerContactDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_DownloadSurveyPartnerContactDetailsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useObt_DownloadSurveyPartnerContactDetailsQuery(baseOptions: Apollo.QueryHookOptions<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables> & ({ variables: Obt_DownloadSurveyPartnerContactDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>(Obt_DownloadSurveyPartnerContactDetailsDocument, options);
      }
export function useObt_DownloadSurveyPartnerContactDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>(Obt_DownloadSurveyPartnerContactDetailsDocument, options);
        }
// @ts-ignore
export function useObt_DownloadSurveyPartnerContactDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>;
export function useObt_DownloadSurveyPartnerContactDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_DownloadSurveyPartnerContactDetailsQuery | undefined, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>;
export function useObt_DownloadSurveyPartnerContactDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>(Obt_DownloadSurveyPartnerContactDetailsDocument, options);
        }
export type Obt_DownloadSurveyPartnerContactDetailsQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerContactDetailsQuery>;
export type Obt_DownloadSurveyPartnerContactDetailsLazyQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerContactDetailsLazyQuery>;
export type Obt_DownloadSurveyPartnerContactDetailsSuspenseQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerContactDetailsSuspenseQuery>;
export type Obt_DownloadSurveyPartnerContactDetailsQueryResult = Apollo.QueryResult<Obt_DownloadSurveyPartnerContactDetailsQuery, Obt_DownloadSurveyPartnerContactDetailsQueryVariables>;
export const Obt_DownloadSurveyPartnerChannelDetailsDocument = gql`
    query Obt_DownloadSurveyPartnerChannelDetails($criteria: DownloadSurveyPartnerChannelInput!) {
  obtDownloadSurveyPartnerChannelDetails(criteria: $criteria) {
    id
    partnerno
    idpartner
    companycode
    invprocess
    validfrom
    validto
    status
    channeltype
    direction
    format
    count
    provider
    newProcess
    anlageUser
    anlageDatum
    aenderungUser
    aenderungDatum
  }
}
    `;

/**
 * __useObt_DownloadSurveyPartnerChannelDetailsQuery__
 *
 * To run a query within a React component, call `useObt_DownloadSurveyPartnerChannelDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_DownloadSurveyPartnerChannelDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_DownloadSurveyPartnerChannelDetailsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useObt_DownloadSurveyPartnerChannelDetailsQuery(baseOptions: Apollo.QueryHookOptions<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables> & ({ variables: Obt_DownloadSurveyPartnerChannelDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>(Obt_DownloadSurveyPartnerChannelDetailsDocument, options);
      }
export function useObt_DownloadSurveyPartnerChannelDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>(Obt_DownloadSurveyPartnerChannelDetailsDocument, options);
        }
// @ts-ignore
export function useObt_DownloadSurveyPartnerChannelDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>;
export function useObt_DownloadSurveyPartnerChannelDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_DownloadSurveyPartnerChannelDetailsQuery | undefined, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>;
export function useObt_DownloadSurveyPartnerChannelDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>(Obt_DownloadSurveyPartnerChannelDetailsDocument, options);
        }
export type Obt_DownloadSurveyPartnerChannelDetailsQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerChannelDetailsQuery>;
export type Obt_DownloadSurveyPartnerChannelDetailsLazyQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerChannelDetailsLazyQuery>;
export type Obt_DownloadSurveyPartnerChannelDetailsSuspenseQueryHookResult = ReturnType<typeof useObt_DownloadSurveyPartnerChannelDetailsSuspenseQuery>;
export type Obt_DownloadSurveyPartnerChannelDetailsQueryResult = Apollo.QueryResult<Obt_DownloadSurveyPartnerChannelDetailsQuery, Obt_DownloadSurveyPartnerChannelDetailsQueryVariables>;
export const Obt_DownloadSurveyExcelDocument = gql`
    query Obt_DownloadSurveyExcel($criteria: IObtSurveySearchCriteriaInput!) {
  obtDownloadSurveyExcel(criteria: $criteria)
}
    `;

/**
 * __useObt_DownloadSurveyExcelQuery__
 *
 * To run a query within a React component, call `useObt_DownloadSurveyExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_DownloadSurveyExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_DownloadSurveyExcelQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useObt_DownloadSurveyExcelQuery(baseOptions: Apollo.QueryHookOptions<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables> & ({ variables: Obt_DownloadSurveyExcelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>(Obt_DownloadSurveyExcelDocument, options);
      }
export function useObt_DownloadSurveyExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>(Obt_DownloadSurveyExcelDocument, options);
        }
// @ts-ignore
export function useObt_DownloadSurveyExcelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>;
export function useObt_DownloadSurveyExcelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_DownloadSurveyExcelQuery | undefined, Obt_DownloadSurveyExcelQueryVariables>;
export function useObt_DownloadSurveyExcelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>(Obt_DownloadSurveyExcelDocument, options);
        }
export type Obt_DownloadSurveyExcelQueryHookResult = ReturnType<typeof useObt_DownloadSurveyExcelQuery>;
export type Obt_DownloadSurveyExcelLazyQueryHookResult = ReturnType<typeof useObt_DownloadSurveyExcelLazyQuery>;
export type Obt_DownloadSurveyExcelSuspenseQueryHookResult = ReturnType<typeof useObt_DownloadSurveyExcelSuspenseQuery>;
export type Obt_DownloadSurveyExcelQueryResult = Apollo.QueryResult<Obt_DownloadSurveyExcelQuery, Obt_DownloadSurveyExcelQueryVariables>;